// @flow
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  abortUpload,
  importProjects,
  removeFile,
  toggleImportDialog,
  uploadFile,
} from '../../actions/projectList';
import FileDropzone from '../../components/FileDropzone/FileDropzone';
import LoadingIndicator from '../../components/LoadingIndicator/LoadingIndicator';
import ModalDialog from '../../components/ModalDialog/ModalDialog';
import ServerError from '../../components/ServerError/ServerError';
import './ImportProjectsDialogContainer.css';

export type Props = {
  abortUpload: Function,
  error: ?any,
  importProjects: Function,
  isFetching: boolean,
  removeFile: Function,
  show: boolean,
  tempFile: ?any,
  tempUploadId: ?string,
  toggleImportDialog: Function,
  uploadedFile: ?any,
  uploadFile: Function,
};

class ImportProjectsDialogContainer extends Component<Props> {
  props: Props;
  onCloseDialog() {
    this.props.toggleImportDialog(false);
  }

  render() {
    const {
      error,
      importProjects,
      isFetching,
      removeFile,
      show,
      tempFile,
      tempUploadId,
      abortUpload,
      uploadedFile,
      uploadFile,
    } = this.props;

    return (
      <div>
        <ModalDialog
          onClose={() => this.onCloseDialog()}
          show={show}>
          <LoadingIndicator isLoading={isFetching} />
          <div className="row ImportProjectsDialogContainer">
            <div className="column">
              <ServerError error={error} />
              <FileDropzone
                label="Excelfil"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                file={uploadedFile}
                upload={tempFile}
                onRemove={() => removeFile()}
                onUpload={f => uploadFile(f)}
                onUploadAbort={() => abortUpload(tempUploadId)} />
              <div className="update-comment">
                Här kan du importera nya projekt samt uppdatera existerande.<br/>
                Vid import av existerande projekt uppdateras detta med nya användare.
              </div>
              {uploadedFile &&
                <button
                  type="button"
                  className="success expanded button"
                  onClick={() => importProjects(uploadedFile)}>
                  Importera
                </button>
              }
              <button
                type="button"
                className="expanded button"
                onClick={() => this.onCloseDialog()}>
                Stäng
              </button>
            </div>
          </div>
        </ModalDialog>
      </div>
    );
  }
}

const mapStateToProps = ({
  projectList: {
    imported: {
      error,
      isFetching,
      show,
      tempUploadId,
      uploadedFile,
    },
  },
  files: {byId},
}) => ({
  error,
  isFetching,
  show,
  tempUploadId,
  tempFile: tempUploadId ? byId[tempUploadId] : null,
  uploadedFile,
});

const mapDispatchToProps = dispatch => ({
  abortUpload: tempId =>
    dispatch(abortUpload(tempId)),
  importProjects: file => {
    if (file) {
      dispatch(importProjects(file));
    }
  },
  removeFile: () =>
    dispatch(removeFile()),
  toggleImportDialog: show =>
    dispatch(toggleImportDialog(show)),
  uploadFile: ([file, ...rest]) => {
    if (file) {
      dispatch(uploadFile(file));
    }
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImportProjectsDialogContainer);



// WEBPACK FOOTER //
// ./src/containers/ImportProjectsDialogContainer/ImportProjectsDialogContainer.js